/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * authentication_service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Ordered from least to most access top -> bottom
 */
export type TeamRole = (typeof TeamRole)[keyof typeof TeamRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TeamRole = {
  member: 'member',
  admin: 'admin',
  owner: 'owner',
} as const;
